var nhb = {
    init: function() {

        nhb.hideMegaMenuTitles();


    },

    hideMegaMenuTitles: function() {
        var divs = document.querySelectorAll(".megamenu__col-title a");
        Array.from(divs).forEach(function(div) {
            if (div.textContent.indexOf("hiddenTitle") >= 0 ) {
                div.style.display = "none";
            }
        });
    }

}


nhb.init();